/**
 * Compact relative-time string for activity feeds: "just now", "5m ago",
 * "3h ago", "2d ago", "1mo ago", "1y ago". Granularity drops as the gap grows.
 */
export function formatRelativeTime(date: string | Date): string {
	const then = (typeof date === 'string' ? new Date(date) : date).getTime();
	const diffSeconds = Math.round((Date.now() - then) / 1000);
	if (diffSeconds < 60) return 'just now';
	const diffMinutes = Math.round(diffSeconds / 60);
	if (diffMinutes < 60) return `${diffMinutes}m ago`;
	const diffHours = Math.round(diffMinutes / 60);
	if (diffHours < 24) return `${diffHours}h ago`;
	const diffDays = Math.round(diffHours / 24);
	if (diffDays < 30) return `${diffDays}d ago`;
	const diffMonths = Math.round(diffDays / 30);
	if (diffMonths < 12) return `${diffMonths}mo ago`;
	return `${Math.round(diffMonths / 12)}y ago`;
}

/** Terse form for dense cells: "now", "5m", "3h", "2d", "1mo", "1y". */
export function formatShortRelativeTime(date: string | Date): string {
	const long = formatRelativeTime(date);
	return long === 'just now' ? 'now' : long.replace(/ ago$/, '');
}

/**
 * The viewer's IANA zone (e.g. "Asia/Kolkata"). Grids render timestamps in it, so
 * date-only filters must be sent with it or the server cuts days in its own zone.
 */
export function browserTimeZone(): string | undefined {
	return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
}
